import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type IPhoneNoInputProps,
  PhoneNoInput,
} from "src/shared/forms/inputs/PhoneNoInput";

export interface IContactMobileNoInputProps extends IPhoneNoInputProps {}

export const ContactMobileNoInput = ({
  label = <FormattedMessage id="contacts.mobile_no" />,
  ...rest
}: IContactMobileNoInputProps) => (
  <PhoneNoInput
    {...rest}
    label={label}
    isRequired={false}
    minLength={9}
    maxLength={15}
  />
);
